export const authStateCookieName = "auth.authenticated";
export const authTokenCookieName = "auth.token";
export const authOriginalTokenCookieName = "auth.original_token";
export const authOriginalUserNameCookieName = "auth.original_user_name";
export const settingsCookieConsentCookieName = "settings.cookie-consent";
export const settingsAdsDisabledCookieName = "settings.ads-disable";
export const settingsPushCookieName = "settings.push";
